import { Tooltip, type TooltipPropsInterface } from '@zillow/constellation-10';

type IconButtonTooltipProps = {
  content: string;
  enableHoverDelay?: boolean;
  placement?: TooltipPropsInterface['placement'];
  trigger: React.ReactNode;
};

export default function IconButtonTooltip({
  content,
  enableHoverDelay = true,
  trigger,
  placement = 'top',
}: IconButtonTooltipProps) {
  const hoverProps = enableHoverDelay ? { delay: { open: 300, close: 0 } } : undefined;

  return (
    <Tooltip
      content={content}
      placement={placement}
      shouldAwaitInteractionResponse
      shouldCloseOnViewportLeave
      trigger={trigger}
      useHoverProps={hoverProps}
    />
  );
}
